// extracted by mini-css-extract-plugin
module.exports = {"gridList":"loading_gridList__ldJus","table":"loading_table__tsWy4"};